const ID_API_TOKEN = 'id_api_token';
const LOGGED_IN_PANEL = 'logged_in_panel';
const LOGGED_IN_COMP_EMAIL = 'logged_in_comp_email';
const LOGGED_IN_ADMIN_EMAIL = 'logged_in_admin_email';
const LOGGED_IN_COMP_PASS = 'logged_in_comp_pass';
const COMP_REMEMBER_ME = 'comp_remember_me';
const ADMIN_REMEMBER_ME = 'admin_remember_me';
const LOGGED_IN_ADMIN_PASS = 'logged_in_admin_pass';
const SIDEBAR = 'sidebar';
const PROFILE_IMAGE = 'profile_image';



export const getToken = () => {
    return window.localStorage.getItem(ID_API_TOKEN)
};

export const getTLoggedInPanel = () => {
    return window.localStorage.getItem(LOGGED_IN_PANEL)
};

export const getCompanyEmail = () => {
    return window.localStorage.getItem(LOGGED_IN_COMP_EMAIL)
}

export const getAdminEmail = () => {
    return window.localStorage.getItem(LOGGED_IN_ADMIN_EMAIL)
}

export const getCompanyPass = () => {
    return window.localStorage.getItem(LOGGED_IN_COMP_PASS)
}

export const getAdminPass = () => {
    return window.localStorage.getItem(LOGGED_IN_ADMIN_PASS)
}

export const getCompanyRememberMe = () => {
    return window.localStorage.getItem(COMP_REMEMBER_ME)
}

export const getAdminRememberMe = () => {
    return window.localStorage.getItem(ADMIN_REMEMBER_ME)
}

export const getSidebar = () => {
    return window.localStorage.getItem(SIDEBAR)
}

export const getProfileImage = () => {
    return window.localStorage.getItem(PROFILE_IMAGE)
}

export const setCompanyEmail = token => {
    window.localStorage.setItem(LOGGED_IN_COMP_EMAIL, token)
}

export const setAdminEmail = token => {
    window.localStorage.setItem(LOGGED_IN_ADMIN_EMAIL, token)
}

export const setCompanyPass = token => {
    window.localStorage.setItem(LOGGED_IN_COMP_PASS, token)
}

export const setAdminPass = token => {
    window.localStorage.setItem(LOGGED_IN_ADMIN_PASS, token)
}

export const setCompanyRememberMe = token => {
    window.localStorage.setItem(COMP_REMEMBER_ME, token)
}

export const setAdminRememberMe = token => {
    window.localStorage.setItem(ADMIN_REMEMBER_ME, token)
}

export const setToken = token => {
    window.localStorage.setItem(ID_API_TOKEN, token, token);
};

export const setTLoggedInPanel = panel => {
    window.localStorage.setItem(LOGGED_IN_PANEL, panel);
};

export const setSidebar = sidebar => {
    window.localStorage.setItem(SIDEBAR, sidebar);
};

export const setProfileImage = profileImage => {
    window.localStorage.setItem(PROFILE_IMAGE, profileImage);
};

export const unsetToken = () => {
    window.localStorage.removeItem(ID_API_TOKEN);
    window.localStorage.removeItem(LOGGED_IN_PANEL);
    window.localStorage.removeItem(SIDEBAR);
};

export default { getToken, getTLoggedInPanel, setToken, setTLoggedInPanel, unsetToken, getCompanyEmail, getAdminEmail, getCompanyPass, getAdminPass, setCompanyEmail, setAdminEmail, setCompanyPass, setAdminPass, setAdminRememberMe, setCompanyRememberMe, getCompanyRememberMe, getAdminRememberMe, getSidebar, setSidebar, setProfileImage, getProfileImage ,}
